module.exports = __webpack_public_path__ + "fonts/fa-solid.09bc383b.otf";